export const ButtonType = {
	SOLID: 'SOLID',
	GHOST: 'GHOST',
	LINK: 'LINK',
	SOLID_ICON: 'SOLID_ICON',
	GHOST_ICON: 'GHOST_ICON',
	UTILITY: 'UTILITY',
	CHIP: 'CHIP'
};

export const ButtonVariant = {
	NEUTRAL: 'NEUTRAL',
	DESTRUCTIVE: 'DESTRUCTIVE',
	STANDARD: 'STANDARD',
	UTILITY: 'UTILITY',
	CHIP: 'CHIP'
};

export const ButtonSize = {
	default: 'default',
	small: 'small',
	large: 'large',
	extraLarge: 'extraLarge'
};
